module.exports = __webpack_public_path__ + "static/media/hammer-drop.120a92c4.svg";